import React, { useEffect, useState } from "react";

import ButtonPrimary from "../ButtonPrimary";
import Modal from "../Modal";

type WebhookUrlModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onSave: (url: string) => void;
  initialUrl?: string | null;
};

const inputClassName =
  "w-full rounded border border-gray-300 p-2.5 text-sm placeholder-gray-400 focus:border-transparent focus:outline-none focus:ring-2 focus:ring-black";

const WebhookUrlModal = ({
  isOpen,
  onClose,
  onSave,
  initialUrl,
}: WebhookUrlModalProps) => {
  const isEditMode = !!initialUrl;
  const [url, setUrl] = useState("");

  useEffect(() => {
    if (isOpen) {
      setUrl(initialUrl ?? "");
    }
  }, [isOpen, initialUrl]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSave(url);
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={isEditMode ? "Edit Webhook URL" : "Add Webhook URL"}
    >
      <form onSubmit={handleSubmit} className="flex flex-col gap-y-5">
        <div className="flex flex-col gap-y-2">
          <label className="text-sm font-medium text-gray-700">
            Webhook URL
          </label>
          <input
            type="url"
            value={url}
            onChange={(e) => setUrl(e.target.value)}
            placeholder="https://api.example.com/webhooks"
            className={inputClassName}
            required
          />
        </div>

        <div className="flex justify-end pt-4 border-t border-gray-200">
          <ButtonPrimary
            text={isEditMode ? "Save" : "Add"}
            type="submit"
            icon={undefined}
            className=""
          />
        </div>
      </form>
    </Modal>
  );
};

export default WebhookUrlModal;
